import {
  EarningsIcon,
  FilmIcon,
  HomeIcon,
  PerformanceIcon,
  PlusIcon,
} from 'components/shared/Icons'

// export const API_URL = `https://shamimediagroup.com/api/filmmaker/`
export const API_URL = `https://o1j0okg6yj.execute-api.ap-southeast-2.amazonaws.com/`
export const USER_TABLE = `filmmaker-dash-users`

export const authData = [
  {
    route: '/signup',
    title: 'Welcome to Filmmaker Dash!',
    subtitle: 'Create an account to get started.',
  },
  {
    route: '/login',
    title: 'Login to Filmmaker Dash!',
    subtitle: 'Good to see you again.',
  },
  {
    route: '/confirm-signup',
    title: 'Confirm Signup',
    subtitle: 'Check your email for the confirmation code.',
  },
  {
    route: '/forgot-password',
    title: 'Forgot Password',
    subtitle: `No worries, We'll send you reset instructions`,
  },
  {
    route: '/reset-password',
    title: 'Reset Password',
    subtitle: `Set your new password`,
  },
]

export const sidebarData = [
  {
    title: 'Menu',
    route: '',
    icon: HomeIcon,
    routes: [
      // {
      //   route: '/add-submission',
      //   name: 'add submission',
      //   icon: PlusIcon,
      // },
      {
        route: '/all-submissions',
        name: 'all submissions',
        icon: FilmIcon,
      },
      {
        route: '/analytics',
        name: 'Analytics',
        icon: PerformanceIcon,
      },
      // {
      //   route: '/earnings',
      //   name: 'Earnings',
      //   icon: EarningsIcon,
      // },
    ],
  },
  // {
  //   title: 'admin',
  //   route: '/admin',
  //   icon: KeyIcon,
  //   routes: [
  //     {
  //       route: '/qc',
  //       name: 'quality check',
  //       icon: QCIcon,
  //     },
  //     {
  //       route: '/pending',
  //       name: 'pending',
  //       icon: PendingIcon,
  //     },
  //   ],
  // },
  // {
  //   title: 'auth',
  //   route: '/admin',
  //   icon: AuthIcon,
  //   routes: [
  //     {
  //       route: '/users',
  //       name: 'users',
  //       icon: UserIcon,
  //     },
  //   ],
  // },
]

export const genres = [
  { name: 'Action/Adventure' },
  { name: 'Animation' },
  { name: 'Comedy' },
  { name: 'Crime' },
  { name: 'Documentary' },
  { name: 'Fantasy' },
  { name: 'Horror' },
  { name: 'Informational & Educational' },
  { name: 'Music & Performances' },
  { name: 'Mystery' },
  { name: 'Reality Show' },
  { name: 'Sci-Fi' },
  { name: 'Sport & Fitness' },
  { name: 'Thriller' },
  { name: 'Unknown' },
  { name: 'War' },
  { name: 'Western' },
]
export const languages = [
  { name: 'Afrikaans' },
  { name: 'Akan' },
  { name: 'Albanian' },
  { name: 'Amharic' },
  { name: 'Arabic' },
  { name: 'Armenian' },
  { name: 'Azerbaijani' },
  { name: 'Basque' },
  { name: 'Belarusian' },
  { name: 'Bengali' },
  { name: 'Bosnian' },
  { name: 'Bulgarian' },
  { name: 'Burmese' },
  { name: 'Cambodian Khmer' },
  { name: 'Catalan' },
  { name: 'Croatian' },
  { name: 'Czech' },
  { name: 'Danish' },
  { name: 'Dari' },
  { name: 'Dutch' },
  { name: 'Estonian' },
  { name: 'English' },
  { name: 'Farsi' },
  { name: 'Filipino' },
  { name: 'Finnish' },
  { name: 'French' },
  { name: 'Gaelic' },
  { name: 'Galician' },
  { name: 'Georgian' },
  { name: 'German' },
  { name: 'Greek' },
  { name: 'Guarani' },
  { name: 'Gujarati' },
  { name: 'Hebrew' },
  { name: 'Hindi' },
  { name: 'Hungarian' },
  { name: 'Icelandic' },
  { name: 'Indonesian' },
  { name: 'Italian' },
  { name: 'Japanese' },
  { name: 'Javanese' },
  { name: 'Kannada' },
  { name: 'Kazakh' },
  { name: 'Korean' },
  { name: 'Kurdish' },
  { name: 'Latvian' },
  { name: 'Lithuanian' },
  { name: 'Luxembourgish' },
  { name: 'Macedonian' },
  { name: 'Malay' },
  { name: 'Malayalam' },
  { name: 'Maltese' },
  { name: 'Mandarin (Spoken)' },
  { name: 'Manipuri' },
  { name: 'Marathi' },
  { name: 'Moldovan' },
  { name: 'Mongolian' },
  { name: 'Nepali' },
  { name: 'No Language' },
  { name: 'Norwegian' },
  { name: 'Odia' },
  { name: 'Pashto' },
  { name: 'Polish' },
  { name: 'Portuguese' },
  { name: 'Portuguese (Brazil)' },
  { name: 'Punjabi' },
  { name: 'Romanian' },
  { name: 'Russian' },
  { name: 'Samoan' },
  { name: 'Serbian' },
  { name: 'Slovak' },
  { name: 'Slovenian' },
  { name: 'Somali' },
  { name: 'Southern Balochi' },
  { name: 'Spanish (Latin America)' },
  { name: 'Spanish (Spain)' },
  { name: 'Swahili' },
  { name: 'Swedish' },
  { name: 'Tagalog' },
  { name: 'Tajik' },
  { name: 'Tamil' },
  { name: 'Telugu' },
  { name: 'Thai' },
  { name: 'Turkish' },
  { name: 'Turkmen' },
  { name: 'Ukrainian' },
  { name: 'Unknown' },
  { name: 'Urdu' },
  { name: 'Uzbek' },
  { name: 'Vietnamese' },
  { name: 'Xhosa' },
  { name: 'Yiddish' },
  { name: 'Yoruba' },
  { name: 'Zulu' },
]

export const subgenres = [
  { name: 'Action' },
  { name: 'Adventure' },
  { name: 'Bollywood' },
  { name: 'Christmas' },
  { name: 'Courtroom / Legal Drama' },
  { name: 'Crime' },
  { name: 'Disaster' },
  { name: 'Drama' },
  { name: 'Educational' },
  { name: 'Experimental' },
  { name: 'Faith and Religion' },
  { name: 'Family' },
  { name: 'Fantasy' },
  { name: 'Film Noir' },
  { name: 'Gangster' },
  { name: 'History' },
  { name: 'Horror' },
  { name: 'Japanimation' },
  { name: 'Kids' },
  { name: 'LGBTQ+' },
  { name: 'Martial Arts' },
  { name: 'Military' },
  { name: 'Mockumentary' },
  { name: 'Music' },
  { name: 'Musical' },
  { name: 'Mystery' },
  { name: 'Period Drama' },
  { name: 'Pirates' },
  { name: 'Procedural Drama' },
  { name: 'Romance / Love' },
  { name: 'Rom-Com' },
  { name: 'Sex' },
  { name: 'Sports' },
  { name: 'Superhero' },
  { name: 'Suspense' },
  { name: 'War' },
  { name: 'Western' },
]

export const formats = [
  { name: 'Feature Film' },
  { name: 'Short Film' },
  { name: 'Documentary' },
  { name: 'Episodic Show' },
]

export const moods = [
  { name: 'Anger' },
  { name: 'Anxiety' },
  { name: 'Calm' },
  { name: 'Exciting' },
  { name: 'Fear' },
  { name: 'Feel-good' },
  { name: 'Funny' },
  { name: 'Joy' },
  { name: 'Powerful' },
  { name: 'Sad' },
]

export const keywords = [
  { name: 'Adaptation' },
  { name: 'Adrenalin' },
  { name: 'Alien' },
  { name: 'African' },
  { name: 'Anime' },
  { name: 'Apocalypse' },
  { name: 'Asian' },
  { name: 'Avant-garde' },
  { name: 'Award' },
  { name: 'BAFTA' },
  { name: 'Best in Fest' },
  { name: 'Biography' },
  { name: 'Car chase' },
  { name: 'Cartoon' },
  { name: 'Chick flick' },
  { name: 'Christmas' },
  { name: 'Classic' },
  { name: 'Coming of age' },
  { name: 'Courtroom' },
  { name: 'Cult' },
  { name: 'Cyborg' },
  { name: 'Death' },
  { name: 'Demon / Devil' },
  { name: 'Disability' },
  { name: 'Destruction' },
  { name: 'Drugs' },
  { name: 'Dystopia' },
  { name: 'Epic' },
  { name: 'Espionage' },
  { name: 'Fairytale' },
  { name: 'Family' },
  { name: 'Female' },
  { name: 'Femme Fatale' },
  { name: 'Festival' },
  { name: 'Flight' },
  { name: 'Film School' },
  { name: 'Found Footage' },
  { name: 'Futuristic' },
  { name: 'Game' },
  { name: 'Gang' },
  { name: 'Gay' },
  { name: 'Ghost' },
  { name: 'God' },
  { name: 'Gore' },
  { name: 'Gorilla Film Making' },
  { name: 'Halloween' },
  { name: 'Heist' },
  { name: 'Hispanic' },
  { name: 'Jesus' },
  { name: 'Kidnap' },
  { name: 'Kung Fu' },
  { name: 'Lesbian' },
  { name: 'Magic' },
  { name: 'Medieval' },
  { name: 'Midnight' },
  { name: 'Miracle' },
  { name: 'Mockumentary' },
  { name: 'Monster' },
  { name: 'Murder' },
  { name: 'Mythical' },
  { name: 'Nightmare' },
  { name: 'Oscar' },
  { name: 'Paranormal' },
  { name: 'Parenthood' },
  { name: 'Parody' },
  { name: 'Police' },
  { name: 'Politics' },
  { name: 'Psychopaths' },
  { name: 'Prank' },
  { name: 'Quest' },
  { name: 'Race issues' },
  { name: 'Relationship' },
  { name: 'Religion' },
  { name: 'Remake' },
  { name: 'Road Movie' },
  { name: 'Robbery' },
  { name: 'Robot' },
  { name: 'Santa' },
  { name: 'Satire' },
  { name: 'School' },
  { name: 'Sex' },
  { name: 'Slapstick' },
  { name: 'Slasher' },
  { name: 'South American' },
  { name: 'Space' },
  { name: 'Spiritual' },
  { name: 'Spoof' },
  { name: 'Star / Celebrity' },
  { name: 'Strong female' },
  { name: 'Suicide' },
  { name: 'Superhero' },
  { name: 'Supernatural' },
  { name: 'Terrorism' },
  { name: 'Time Travel' },
  { name: 'Tragedy' },
  { name: 'Utopian' },
  { name: 'Valentine' },
  { name: 'Vampire' },
  { name: 'Vengeance / Revenge' },
  { name: 'Vintage' },
  { name: 'Violence' },
  { name: 'Virtual Reality(VR)' },
  { name: 'Werewolf' },
  { name: 'Youth' },
  { name: 'Zombie' },
]

export const years = [
  { value: '', label: '--' },
  { value: '2019', label: '2019' },
  { value: '2020', label: '2020' },
  { value: '2021', label: '2021' },
  { value: '2022', label: '2022' },
  { value: '2023', label: '2023' },
  { value: '2024', label: '2024' },
  { value: '2025', label: '2025' },
  { value: '2026', label: '2026' },
  { value: '2027', label: '2027' },
  { value: '2028', label: '2028' },
  { value: '2029', label: '2029' },
  { value: '2030', label: '2030' },
  { value: '2031', label: '2031' },
  { value: '2032', label: '2032' },
  { value: '2033', label: '2033' },
  { value: '2034', label: '2034' },
  { value: '2035', label: '2035' },
]
export const quarters = [
  { value: '', label: '--' },
  { value: '1ST', label: '1ST' },
  { value: '2ND', label: '2ND' },
  { value: '3RD', label: '3RD' },
  { value: '4TH', label: '4TH' },
]
